import Delta from 'quill-delta';
import { useTranslation } from 'react-i18next';

import { useLocalize } from '@treams/treams-hooks';
import { LocalizedAttributedString } from '@treams/treams-network';
import { Paragraph, QuillText } from '@treams/treams-ui';

type Props = {
	description: LocalizedAttributedString | null | undefined;
};

export const SelectConversationCardDescription = ({ description }: Props) => {
	const { t } = useTranslation('', { keyPrefix: 'evaluations.create.modal.form.description' });
	const { localize } = useLocalize();

	const emptyLabel = t('empty');

	const isDescriptionEmpty =
		description === undefined ||
		description === null ||
		QuillText.isEmpty(localize(description).text);

	const label = isDescriptionEmpty ? new Delta().insert(emptyLabel) : localize(description).text;

	return (
		<Paragraph>
			<QuillText value={label} />
		</Paragraph>
	);
};
